import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { auth } from "services";

function Settings() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  }

  return (
    <div className="container">
      <div className="row mt-3 mt-md-5">
        <div className="col-md-1 col-2">
          <a role="button" className="btn btn-app" onClick={goBack} title="Back">
            <i className="bi bi-arrow-left"></i>
          </a>
        </div>
        <div className="col-md-11 col-10">
          <h1 className="">Settings</h1>
        </div>


      </div>
      <hr />
      <p className="mt-3">Coming Soon</p>
    </div>
  )
}

export default Settings;
